import { I18nPaths } from "types/gatsby";
const cache: Map<string, I18nPaths> = new Map();

function removeDraft(pageId: undefined | null): undefined;
function removeDraft(pageId: string): string;
function removeDraft(pageId: string | undefined | null): string | undefined {
  if (!pageId) return undefined;
  return pageId.replace("drafts.", "");
}

export function cachePagePaths(pageId: string, paths: I18nPaths): void {
  cache.set(removeDraft(pageId), paths);
}

export function getPagePaths(
  pageId: string | undefined | null
): I18nPaths | undefined {
  if (!pageId) return undefined;
  return cache.get(removeDraft(pageId));
}

export function getAll(): Map<string, I18nPaths> {
  return cache;
}

export { removeDraft };
